import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

export const supportedLngs = [
  // Order is respected when matching in useLanguageInit
  'de-DE',
  'en',
  'id-ID',
  'it',
  'pt-BR',
  'zh-HK',
  'zh-CN',
];

i18n
  // Load translation using http -> see /public/locales
  .use(Backend)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: {
      id: ['id-ID'],
      zh: ['zh-HK'],
      pt: ['pt-BR'],
      default: ['en'],
    },
    supportedLngs,

    // Backend options for loading translation files
    backend: {
      loadPath:
        import.meta.env.DEV === true
          ? '/locales/{{lng}}/{{ns}}.json'
          : `${import.meta.env.VITE_WIDGET_DOMAIN}/locales/{{lng}}/{{ns}}.json`,
    },
    // Default namespace
    defaultNS: 'common',
    ns: ['common'],
  });

export default i18n;
